export default __webpack_public_path__ + "static/media/SAS0030.34I-32347_-17812_0.c7d2e0bc.jpg";